export var selectSavedInFolders = function selectSavedInFolders(state) {
  return state.favoritesAssignWidget.savedInFolders;
};